import { styled } from 'ui/styles'

export const Post = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`
